import company11 from "../assets/ajmera_realty.png";
import company12 from "../assets/welspun_logo.png";
import company13 from "../assets/indus_towers.png";
import company14 from "../assets/growisto.png";
import company21 from "../assets/iitbdrf_logo.png";
import company22 from "../assets/lanxess-updated.png";
import company23 from "../assets/freyr-energy.png";
import company24 from "../assets/altisourcelogo.png";

const partnercompanyimages = [
  [company11, company12, company13, company14],
  [company21, company22, company23, company24],
];
export default partnercompanyimages;
